import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import {SnackbarProvider} from "notistack";
// import useDynamicMaxSnack from './hooks/useDynamicMaxSnack'; 

import * as serviceWorker from "./serviceWorker";
import App from "./app/App";

// third party style
import "perfect-scrollbar/css/perfect-scrollbar.css";


const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <SnackbarProvider maxSnack={10}>
      <App />
    </SnackbarProvider>
  </BrowserRouter>
);

// for IE-11 support un-comment cssVars() and it's import in this file
// and in MatxTheme file

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
